import { SVGProps, Ref, forwardRef } from 'react';

export const HeadsetFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2.8c2.363 0 3.832.883 4.742 2.13.678.931 1.084 2.12 1.258 3.418V16.8c0 .823-.229 1.403-.717 1.806-.473.39-1.314.722-2.778.784a2.5 2.5 0 0 0-.446-.82c-.475-.569-1.186-.87-2.059-.87s-1.584.302-2.059.87c-.45.541-.591 1.209-.591 1.78s.141 1.239.591 1.78c.475.569 1.186.87 2.059.87s1.584-.301 2.059-.87a2.5 2.5 0 0 0 .482-.94c1.7-.067 2.993-.456 3.889-1.196.39-.322.68-.69.892-1.089q.24-.035.478-.086c2.293-.49 4.2-2.03 4.2-5.319 0-3.288-1.907-4.83-4.2-5.319l-.007-.001c-.198-1.548-.688-3.063-1.597-4.31C16.918 2.117 14.886 1 12 1 9.113 1 7.082 2.117 5.804 3.87c-.909 1.247-1.399 2.762-1.597 4.31L4.2 8.18c-2.293.49-4.2 2.03-4.2 5.32 0 3.288 1.907 4.828 4.2 5.318A8.7 8.7 0 0 0 6 19V8.348c.174-1.298.58-2.487 1.258-3.418C8.168 3.683 9.637 2.8 12 2.8"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeadsetFilledSize24Glyph.displayName = 'HeadsetFilledSize24Glyph';
